import de from '@translations/de/catalogues.json';
import en from '@translations/en/catalogues.json';
import pl from '@translations/pl/catalogues.json';
import sl from '@translations/sl/catalogues.json';
import uk from '@translations/uk/catalogues.json';
import bg from '@translations/bg/catalogues.json';
import cz from '@translations/cz/catalogues.json';
import fr from '@translations/fr/catalogues.json';
import gr from '@translations/gr/catalogues.json';
import it from '@translations/it/catalogues.json';
import pr from '@translations/pr/catalogues.json';
import ru from '@translations/ru/catalogues.json';
import sk from '@translations/sk/catalogues.json';
import sp from '@translations/sp/catalogues.json';
import tr from '@translations/tr/catalogues.json';
import hu from '@translations/hu/catalogues.json';
import { ITranslations } from '@/types/common';
import { CataloguesTransFields } from './types';

export const cataloguesTranslations: ITranslations<CataloguesTransFields> = {
  name: 'catalogues',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
